export default __webpack_public_path__ + "static/media/prime.a4eeb615.jpg";